export enum EPurPose {
  ENTRANCE = 1,
  EXIT,
  APB_ENTRANCE,
  APB_EXIT,
  RESTAURANT = 5,
  ESCORT_ENTRANCE = 0x11,
  ESCORT_EXIT
}

export enum ERelayMode {
  NOT_USE,
  AUTH_OK,
  AUTH_ERROR,
  ENTRANCE,
  EXIT
}

export enum EDeviceType {
  UNKNOWN = -1,
  AX_ACU = 0,
  ACCU_BANK_5400 = 1,
  ACCU_BANK_5800 = 2,
  AX_PDA = 10,
  AX_ACU_EV = 15,
  ACCU_BANK_EV_5800 = 16,
  MAIN_SERVER = 20,
  SYNC_SERVER = 30,
  SHELL_CLIENT = 40,
  FINGERPRINT_SERVER_SUPREMA = 60,
  AX_SLA = 100,
  AX_WEB = 200
}

export enum ENoNc {
  NO,
  NC
}

export enum EOperationMode {
  ID_ONLY = 1,
  ID_AND_PIN,
  DUAL_ID
}

export enum EOperationOnFire {
  DONT_CARE,
  OPEN,
  CLOSE
}

export enum ESensorLinkedRelayMode {
  NO_RELAY,
  RELAY_AUTO_ON,
  RELAY_OFF_BY_ADMIN,
  RELAY_ON_OFF_BY_ADMIN
}

export enum ESensorReleaseMode {
  RELEASE_AUTO,
  RELEASE_BY_ADMIN
}
